/* Utility-balk: rotatie op mobiel.
   Op desktop staan alle items naast elkaar en doet dit script niets.
   Respecteert prefers-reduced-motion: dan blijft het eerste item staan. */

class OnvelaUtility extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.onvela-utility__item'));
    if (this.items.length < 2) return;

    this.seconds = parseInt(this.dataset.autoplay || '4', 10);
    this.index = 0;
    this.mqMobile = window.matchMedia('(max-width: 749px)');
    this.mqMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.onChange = () => this.sync();
    this.mqMobile.addEventListener('change', this.onChange);
    this.mqMotion.addEventListener('change', this.onChange);

    // Niet doorrotëren als het tabblad op de achtergrond staat.
    this.onVisibility = () => (document.hidden ? this.stop() : this.sync());
    document.addEventListener('visibilitychange', this.onVisibility);

    this.sync();
  }

  disconnectedCallback() {
    this.stop();
    this.mqMobile?.removeEventListener('change', this.onChange);
    this.mqMotion?.removeEventListener('change', this.onChange);
    document.removeEventListener('visibilitychange', this.onVisibility);
  }

  sync() {
    const rotate = this.mqMobile.matches && !this.mqMotion.matches && this.seconds > 0;
    this.classList.toggle('onvela-utility--rotating', rotate);

    if (!rotate) {
      this.stop();
      this.items.forEach((el) => el.classList.remove('is-active'));
      return;
    }

    this.show(this.index % this.items.length);
    this.start();
  }

  show(i) {
    this.index = i;
    this.items.forEach((el, n) => el.classList.toggle('is-active', n === i));
  }

  start() {
    this.stop();
    this.timer = setInterval(() => {
      this.show((this.index + 1) % this.items.length);
    }, this.seconds * 1000);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }
}

if (!customElements.get('onvela-utility')) {
  customElements.define('onvela-utility', OnvelaUtility);
}
